import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { SettingsService } from 'src/app/settings/settings.service';

@Component({
    selector: 'loading-interno',
    templateUrl: './loading-interno.html',
    styleUrls: ['./loading-interno.scss'],
    standalone: false
})


export class LoadingInterno implements OnInit, OnDestroy {



  constructor(
    private settings:SettingsService, 
  ) { 




  }





  @Input() totalDurationMinutes: number = 1; 
  
  progress: number = 0;
  currentMessage: string = 'La información está siendo procesada.';
  subMessage: string = 'Esto no tomará mucho tiempo.';
  estimatedTimeRemaining: string = '';

  private intervalId: any;
  private messageIndex: number = 0;
  private messages: string[] = [
    'Validando datos...',
    'Generando simulación...',
    'Calculando resultados complejos...',
    'Aplicando mejores condiciones...',
    'Casi listo...'
  ];

  ngOnInit(): void {
    this.startLoadingSimulation();
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  private startLoadingSimulation(): void {
    const totalMilliseconds = this.totalDurationMinutes * 60 * 1000;
    const updateInterval = 1000; 
    const totalSteps = totalMilliseconds / updateInterval;
    const progressPerStep = 100 / totalSteps;

    this.intervalId = setInterval(() => {
      this.progress += progressPerStep;
      

      if (this.progress > 100) {
        this.progress = 100;
      }

      const messageStep = 100 / this.messages.length;
      const newIndex = Math.floor(this.progress / messageStep);

      if (newIndex < this.messages.length && newIndex !== this.messageIndex) {
        this.subMessage = this.messages[newIndex];
        this.messageIndex = newIndex;
      } else if (this.progress >= 95 && this.messageIndex === this.messages.length -1) {
        this.subMessage = '¡Ya casi terminamos!'; 
      }


      const elapsedPercentage = this.progress / 100;
      const remainingMilliseconds = totalMilliseconds * (1 - elapsedPercentage);

      if (remainingMilliseconds > 0 && this.progress < 100) {
        let minutes = Math.floor(remainingMilliseconds / (60 * 1000));
        let seconds = Math.floor((remainingMilliseconds % (60 * 1000)) / 1000);
        this.estimatedTimeRemaining = `Tiempo restante estimado: ${minutes}m ${seconds}s`;
      } else if (this.progress >= 100) {
        this.currentMessage = '¡Ya casi, queda poco!';
        this.subMessage = 'Redirigiendo o mostrando resultados...';
        this.estimatedTimeRemaining = '';
        clearInterval(this.intervalId); 
      }
    }, updateInterval);
  }



}

